module.exports = __webpack_public_path__ + "static/media/Compass.8e0bd689.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/Compass.svg
// module id = 382
// module chunks = 0